// import { t } from 'i18next';
// import { useSelector } from 'react-redux';
// import { CircularProgress } from '@mui/material';
// export default function Giftselectioncards({
//   data,
//   title,
//   img,
//   id,
//   onClick,
//   projectGuID,
//   totalCost,
//   isLoading = false,
// }) {
//   const isActive = useSelector((state) => state.toggle.isActive);
//   // const handleClick = (e, projectTypeIdInt) => {
//   //   const buttons = document.querySelectorAll('.selectbutton');

//   //   buttons.forEach((button) => {
//   //     if (button === e.target) {
//   //       button.textContent = button.textContent === t('Select') ? t('Selected') : t('Select');

//   //       // Disable the button when it's selected
//   //       button.disabled = button.textContent === t('Selected');

//   //       const formSection = document.getElementById('form-section');
//   //       if (formSection) {
//   //         formSection.scrollIntoView({
//   //           behavior: 'smooth',
//   //           block: 'start',
//   //           inline: 'nearest',
//   //         });
//   //       }
//   //     } else {
//   //       button.textContent = t('Select');
//   //       // Enable the button when it's not selected
//   //       button.disabled = false;
//   //     }
//   //   });

//   //   onClick(projectGuID, projectTypeIdInt);
//   // };
//   const handleClick = (e, projectTypeIdInt) => {
//     if (isLoading) return; // Prevent click if loading

//     const buttons = document.querySelectorAll('.selectbutton');

//     buttons.forEach((button) => {
//       if (button === e.target) {
//         button.textContent = button.textContent === t('Select') ? t('Selected') : t('Select');

//         // Disable the button when it's selected
//         button.disabled = button.textContent === t('Selected');

//         const formSection = document.getElementById('form-section');
//         if (formSection) {
//           formSection.scrollIntoView({
//             behavior: 'smooth',
//             block: 'start',
//             inline: 'nearest',
//           });
//         }
//       } else {
//         button.textContent = t('Select');
//         // Enable the button when it's not selected
//         button.disabled = false;
//       }
//     });

//     onClick(projectGuID, projectTypeIdInt);
//   };

//   return (
//     <div
//       key={id}
//       className=" hover:scale-105 transition-transform duration-300 block ml-4 mt-4 w-72 dark:bg-neutral-700 text-center shadow px-3  rounded-3xl"
//     >
//       <h5 className=" p-3 text-xl tracking-wide  capitalize text-customgreen text-center">
//         {isActive
//           ? title.length > 15
//             ? `${title.slice(0, 15)}...`
//             : title
//           : title.length > 15
//             ? `${title.slice(0, 15)}...`
//             : title}
//         {/* {title} */}
//       </h5>

//       <img className="w-full h-32 rounded-t-3xl " src={`data:image/jpeg;base64,${img}`} alt={title} />

//       <div className="py-6">
//         <div className="flex justify-center items-center p-3 align-middle  gap-2">
//           <h5 className="md:my-3 my-2 text-md text-center text-sm font-bold tracking-tight text-gray-900 ">
//             {' '}
//             {t('Total Cost')} <span className={isActive ? 'mr-2' : 'ml-2'}>:</span>
//             <span className={`mx-2 text-customorange font-bold ${isActive ? 'mr-2' : 'ml-2'}`}>{totalCost}</span>
//             {t('AED')}
//           </h5>
//         </div>
//         {/* <button
//           type="button"
//           name="ProjecttypeId"
//           onClick={(e) => handleClick(e, data?.projectTypeIdInt)}
//           className="w-full text-white selectbutton bg-customgreen hover:bg-hovergreen  font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
//         >
//           {t('Select')}
//         </button> */}
//         <button
//           type="button"
//           name="ProjecttypeId"
//           onClick={(e) => handleClick(e, data?.projectTypeIdInt)}
//           className="w-full text-white selectbutton bg-customgreen hover:bg-hovergreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1 relative"
//           disabled={isLoading} // Disable button when loading
//         >
//           {isLoading ? (
//             <div className="flex justify-center items-center">
//               <CircularProgress size={20} color="inherit" style={{ color: 'white' }} />
//             </div>
//           ) : (
//             t('Select')
//           )}
//         </button>
//       </div>
//     </div>
//   );
// }

import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';

export default function Giftselectioncards({
  data,
  title,
  img,
  id,
  onClick,
  projectGuID,
  totalCost,
  isLoading = false,
  isSelected = false, // Add isSelected prop
}) {
  const isActive = useSelector((state) => state.toggle.isActive);

  const handleClick = (e, projectTypeIdInt) => {
    if (isLoading || isSelected) return; // Prevent click if loading or already selected

    onClick(projectGuID, projectTypeIdInt);
  };

  return (
    <div
      key={id}
      className=" hover:scale-105 transition-transform duration-300 block ml-4 mt-4 w-72 dark:bg-neutral-700 text-center shadow px-3  rounded-3xl"
    >
      <h5 className=" p-3 text-xl tracking-wide  capitalize text-customgreen text-center">
        {isActive
          ? title.length > 15
            ? `${title.slice(0, 15)}...`
            : title
          : title.length > 15
            ? `${title.slice(0, 15)}...`
            : title}
      </h5>

      <img className="w-full h-32 rounded-t-3xl " src={`data:image/jpeg;base64,${img}`} alt={title} />

      <div className="py-6">
        <div className="flex justify-center items-center p-3 align-middle  gap-2">
          <h5 className="md:my-3 my-2 text-md text-center text-sm font-bold tracking-tight text-gray-900 ">
            {' '}
            {t('Total Cost')} <span className={isActive ? 'mr-2' : 'ml-2'}>:</span>
            <span className={`mx-2 text-customorange font-bold ${isActive ? 'mr-2' : 'ml-2'}`}>{totalCost}</span>
            {t('AED')}
          </h5>
        </div>
        <button
          type="button"
          name="ProjecttypeId"
          onClick={(e) => handleClick(e, data?.projectTypeIdInt)}
          className={`w-full text-white selectbutton bg-customgreen hover:bg-hovergreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1 relative ${isSelected ? 'opacity-70 cursor-not-allowed' : ''}`} // Add styles for selected state
          disabled={isLoading || isSelected} // Disable button when loading or selected
        >
          {isLoading ? (
            <div className="flex justify-center items-center">
              <CircularProgress size={20} color="inherit" style={{ color: 'white' }} />
            </div>
          ) : isSelected ? (
            t('Selected')
          ) : (
            t('Select')
          )}
        </button>
      </div>
    </div>
  );
}
